// Erreurs et construction de l'erreur HTTP partagées par tous les endpoints Praetoria.
export class PraetoriaTimeoutError extends Error {
  constructor() {
    super("La requête Praetoria a expiré.");
    this.name = "PraetoriaTimeoutError";
  }
}

export class PraetoriaCancelledError extends Error {
  constructor() {
    super("La génération a été annulée.");
    this.name = "PraetoriaCancelledError";
  }
}

// Message par défaut aligné sur celui renvoyé par le handler `BaseInjoignableError` de main.py
// (panne de base Postgres, voir CLAUDE.md § "Panne de base = blocage propre"). Réutilisé tel
// quel quand la réponse d'erreur ne contient pas de `detail` exploitable.
export const SERVICE_UNAVAILABLE_MESSAGE = "Service momentanément indisponible, réessayez dans quelques instants.";

// Distingue la panne technique « base de données injoignable » (503, code=indisponibilite_technique)
// des autres erreurs -- pour que l'appelant puisse afficher un message adapté (pas de mention
// "contactez le support", la panne se résout d'elle-même) plutôt que le message générique.
export class ServiceUnavailableError extends Error {
  constructor(message: string = SERVICE_UNAVAILABLE_MESSAGE) {
    super(message);
    this.name = "ServiceUnavailableError";
  }
}

export class TranscriptionError extends Error {
  constructor(
    public readonly status: number,
    message: string
  ) {
    super(message);
    this.name = "TranscriptionError";
  }
}

async function parseErrorBody(response: Response): Promise<{ detail: string; code?: string }> {
  try {
    const errorBody = await response.json();
    return {
      detail:
        typeof errorBody?.detail === "string" && errorBody.detail
          ? errorBody.detail
          : `Praetoria a répondu avec le statut ${response.status}`,
      code: typeof errorBody?.code === "string" ? errorBody.code : undefined,
    };
  } catch {
    // Réponse non-JSON (ou vide) : on garde le message générique ci-dessous.
    return { detail: `Praetoria a répondu avec le statut ${response.status}` };
  }
}

// Construit l'erreur à lever pour une réponse HTTP en échec. 503/code=indisponibilite_technique
// (voir main.py, handler `handle_base_indisponible`) devient une ServiceUnavailableError, que les
// appelants peuvent traiter distinctement d'une erreur générique.
export async function buildApiError(response: Response): Promise<Error> {
  const { detail, code } = await parseErrorBody(response);
  if (response.status === 503 || code === "indisponibilite_technique") {
    return new ServiceUnavailableError(detail);
  }
  return new Error(detail);
}
